import { ComponentView, ViewModel } from "binder";
import { ScrollViewerViewModel } from "./scrollViewer-viewModel"

export class ScrollViewerView extends ComponentView<ScrollViewerViewModel>{
    GetViewUniqueId(): string {
        return "V-BF3CB3D9-A496-4EAD-8ADA-A6E12D3E2D5A"
    }
    loadHtml(): string {
        let element = require('./scrollViewer.html').default;
        let style = require('./scrollViewer.less');
        return element;
    }
    constructor() {
       super();
    }

    public set content(v: ViewModel) { this._content = v; } public get content(): ViewModel { return this._content;} private _content: ViewModel;
    public set horizontal(v: boolean) { this._horizontal = v; } public get horizontal(): boolean { return this._horizontal;} private _horizontal: boolean;
    public set vertical(v: boolean) { this._vertical = v; } public get vertical(): boolean { return this._vertical;} private _vertical: boolean;
    public set beginside(v: boolean) { this._beginside = v; } public get beginside(): boolean { return this._beginside;} private _beginside: boolean;
    private _childPlaceHolder:HTMLDivElement;

    onRenderCompleted(){
        // this._childPlaceHolder = this.firstlevelElement.querySelector('.V-BF3CB3D9-A496-4EAD-8ADA-A6E12D3E2D5A');
    }
    // append(...nodes: (Node | string)[]): void{
    //     this._childPlaceHolder.append(...nodes);
    // }
}
